var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 519,
    height: 309.905,
    viewBox: "0 0 519 309.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1128",
    x: 224,
    y: 94.905,
    width: 252,
    height: 215,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -20,
    dy: 20,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(-125 -40.095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1129",
    "data-name": "Rectangle 1129",
    width: 519,
    height: 272,
    rx: 54,
    transform: "translate(125 49)",
    fill: "#fff",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505",
    transform: "translate(138.307 -51.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2435",
    "data-name": "Group 2435",
    transform: "translate(166.741 91.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M225.207,298.437l4.3-2.479V144.73l-4.3,2.481Z",
    transform: "translate(-88.835 -65.993)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M269.214,172.619l4.3-2.481L137.142,91.4l-4.3,2.484Z",
    transform: "translate(-132.842 -91.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M136.268,103.548l.878,114.319L263.182,289.4l1.388-120.217Zm7.632,18.174,16.468-8.014L261.8,172.271v86.517l-20.091,9.784L143.9,212.105Z",
    transform: "translate(-131.21 -85.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M132.842,93.084V244.306l136.372,78.736V171.817Zm9.787,35.3,16.467-8.014,101.432,58.565v86.521l-20.1,9.779-97.8-56.471Z",
    transform: "translate(-132.842 -90.6)",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M139.471,119.578l16.467-8.014L257.37,170.129V256.65l-20.1,9.779-97.8-56.471Z",
    transform: "translate(-129.684 -81.795)",
    fill: "#24d2c1",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2436",
    "data-name": "Group 2436",
    transform: "translate(65.987 93.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M68.9,286.185l-4.3-2.478V132.483l4.3,2.479Z",
    transform: "translate(-64.601 -74.312)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M68.9,153.734l-4.3-2.479L165.356,93.084l4.3,2.479Z",
    transform: "translate(-64.601 -93.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M69.554,150.293,70.942,270.51l90.418-50.964.876-114.316ZM154.6,213.782l-62.182,35.9L72.327,239.9V153.383l65.811-37.993L154.6,123.4Z",
    transform: "translate(-62.241 -87.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M67.513,152.934V304.156l100.754-58.165V94.763Zm90.968,67.512L96.3,256.347l-20.1-9.779V160.047l65.816-38,16.465,8.017Z",
    transform: "translate(-63.214 -92.284)",
    fill: "#121214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M155.678,211.641,93.5,247.542l-20.1-9.779V151.242l65.816-38,16.465,8.017Z",
    transform: "translate(-60.41 -83.479)",
    fill: "#24d2c1",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2439",
    "data-name": "Group 2439",
    transform: "translate(70.286 230.088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2437",
    "data-name": "Group 2437",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M195.293,316,67.513,242.233v-17.5l127.78,73.773Z",
    transform: "translate(-67.513 -166.562)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M154.059,310.968v-17.5L254.81,235.3v17.5Z",
    transform: "translate(-26.279 -161.527)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M195.293,317.278,67.513,243.5l100.755-58.171L296.044,259.11Z",
    transform: "translate(-67.513 -185.334)",
    fill: "#303033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2438",
    "data-name": "Group 2438",
    transform: "translate(11.721 6.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M280.541,253.237,172.964,191.131H156l-80.553,46.5v6.224L184.2,306.639h14.626l81.718-47.176Z",
    transform: "translate(-75.452 -188.756)",
    fill: "#121214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M280.541,251.628,172.964,189.523H156L75.452,236.028v6.221L184.2,305.034h14.626l81.718-47.18Z",
    transform: "translate(-75.452 -189.523)",
    fill: "#535359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M275.931,252.521,170.9,191.882h-15.1l-78,45.029v2.2l106.2,61.309h12.753l79.168-45.7Z",
    transform: "translate(-74.327 -188.398)",
    fill: "#121214",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2440",
    "data-name": "Group 2440",
    transform: "translate(133.689 252.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M196.765,257.4c-19.747,11.4-51.76,11.4-71.487,0-19.762-11.385-19.762-29.876,0-41.274,19.727-11.4,51.739-11.4,71.487,0S216.5,246.016,196.765,257.4Z",
    transform: "translate(-110.456 -197.375)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M163.761,217.239c-6.43-5.891-20.935-5.962-27.425-.152-3.267,2.926-3.267,6.837-.033,9.812a13.556,13.556,0,0,0,1.915,1.426c6.424-3.9,17.178-3.846,23.53.137a13.156,13.156,0,0,0,1.955-1.4C166.993,224.11,167.006,220.211,163.761,217.239Z",
    transform: "translate(-99.295 -194.9)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M142.757,211.771l-10.713-6.256-10.356,5.918,10.692,6.253a6.919,6.919,0,0,0-.57.571,16.061,16.061,0,0,0-3.616,5.191l-5.426-.034-9.752-.053-.032,8.441,15.187.075A11.952,11.952,0,0,0,129.243,234a17.128,17.128,0,0,0,3.033,3.694l-10.766,6.13,1.144.681,8.956,5.233.211.111,10.756-6.135c.966.36,1.973.67,2.977.967a49.6,49.6,0,0,0,7.022,1.476l-.016,2.573-.019,6.194,14.608.08.038-6.2.012-2.562a52.184,52.184,0,0,0,7.037-1.4c1.022-.286,2.015-.592,2.984-.942l10.684,6.265.205-.1,9.03-5.154,1.152-.66-10.7-6.248a17.471,17.471,0,0,0,3.074-3.673,12.369,12.369,0,0,0,1.109-2.092l15.193.077.033-8.435-9.756-.059-5.429-.018a15.625,15.625,0,0,0-3.536-5.218c-.2-.2-.378-.408-.585-.588l10.766-6.142-10.286-6.024L177.4,211.966a46.944,46.944,0,0,0-10.021-2.447l.062-8.773-14.611-.078-.055,8.772A48.207,48.207,0,0,0,142.757,211.771Zm30.9,21.056a13.153,13.153,0,0,1-1.955,1.4c-6.392,3.905-17.15,3.842-23.53-.137a13.554,13.554,0,0,1-1.915-1.426c-3.235-2.975-3.235-6.886.033-9.812,6.49-5.81,21-5.739,27.425.152C176.963,225.979,176.95,229.878,173.66,232.827Z",
    transform: "translate(-109.252 -200.668)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M118.78,229.9l10.311,6.024L129,248.57l-10.29-6.018Z",
    transform: "translate(-106.523 -186.743)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M136.527,229.82l-.068,12.648-10.778,6.138.09-12.651Z",
    transform: "translate(-103.202 -186.779)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M154.4,237.493l-.049,12.643-14.626-.068.068-12.656Z",
    transform: "translate(-96.509 -183.161)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M143.047,232.264l-.064,12.644a48.513,48.513,0,0,1-10-2.441l.068-12.647C136.048,231.1,143.047,232.264,143.047,232.264Z",
    transform: "translate(-99.724 -186.779)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M128.195,221.83l-.061,8.181-6.6,3.762v.675l-8.6-.055.076-12.638Z",
    transform: "translate(-109.276 -190.621)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M123.29,221.806a16.175,16.175,0,0,0,4.1,5.813l-4.167,2.368Z",
    transform: "translate(-104.371 -190.597)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M167.193,236.208l-.047,12.642L156.451,242.6l.058-12.652Z",
    transform: "translate(-88.542 -186.72)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M174.128,230.18l-.053,12.658-10.38,5.9.047-12.642Z",
    transform: "translate(-85.091 -186.607)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M159.746,229.955c.05-.824-.058,12.652-.058,12.652a44.774,44.774,0,0,1-10.031,2.336c0-.753.068-12.641.068-12.641A54.314,54.314,0,0,0,159.746,229.955Z",
    transform: "translate(-91.779 -186.732)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M181.554,222.12l-.079,12.654-8.593-.051v-.666l-6.571-3.842.051-8.171Z",
    transform: "translate(-83.844 -190.484)",
    fill: "#16a89f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M167.695,222.043l-.05,8.172-4.133-2.407A18.45,18.45,0,0,0,167.695,222.043Z",
    transform: "translate(-85.178 -190.484)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M174.347,208.238l-.058,12.011-6.588-.063a16.619,16.619,0,0,0-4.121-5.805Z",
    transform: "translate(-85.145 -197.061)",
    fill: "#0a8074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M129.6,214.212a17.484,17.484,0,0,0-4.186,5.763l-6.581-.04.074-11.975Z",
    transform: "translate(-106.467 -197.194)",
    fill: "#0a8074"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2446",
    "data-name": "Group 2446",
    transform: "translate(114.917 101.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2441",
    "data-name": "Group 2441",
    transform: "translate(52.847 74.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M137.756,206.63l-4.221-2.441V149.734l4.221,2.433Z",
    transform: "translate(-133.535 -147.841)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M136.394,206.454l3.278-1.894V150.1l-3.278,1.888Z",
    transform: "translate(-132.173 -147.665)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M137.756,152.779l3.278-1.888-4.222-2.439-3.277,1.894Z",
    transform: "translate(-133.535 -148.452)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2442",
    "data-name": "Group 2442",
    transform: "translate(51.283 57.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M138.458,158.245l-5.982-3.448V139.031l5.982,3.451Z",
    transform: "translate(-132.476 -136.355)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M136.528,158l4.644-2.677V139.554l-4.644,2.68Z",
    transform: "translate(-130.545 -136.106)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M138.458,143.346l4.644-2.68-5.989-3.448-4.638,2.677Z",
    transform: "translate(-132.476 -137.218)",
    fill: "#2a4e68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2443",
    "data-name": "Group 2443",
    transform: "translate(45.949 65.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M138.013,144.109v6.906l-6,3.465v-6.9Z",
    transform: "translate(-127.364 -141.424)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M139.512,144.975l-4.637-2.685-6.012,3.472,4.645,2.68Z",
    transform: "translate(-128.863 -142.29)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M133.508,147.321l-4.645-2.68v6.9l4.645,2.68Z",
    transform: "translate(-128.863 -141.17)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2444",
    "data-name": "Group 2444",
    transform: "translate(0 69.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M146.673,146.732v5.788L100.38,179.243v-5.785Z",
    transform: "translate(-96.485 -144.483)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M147.93,147.458l-3.9-2.249L97.742,171.935l3.9,2.249Z",
    transform: "translate(-97.742 -145.209)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M101.637,165.559l-3.9-2.249V169.1l3.9,2.243Z",
    transform: "translate(-97.742 -136.584)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2445",
    "data-name": "Group 2445",
    transform: "translate(52.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M137.756,160.52l-4.221-2.439V99.314l4.221,2.441Z",
    transform: "translate(-133.535 -97.424)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M136.394,160.342l3.278-1.894V99.686l-3.278,1.892Z",
    transform: "translate(-132.173 -97.247)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M137.756,102.365l3.278-1.892-4.222-2.44-3.277,1.89Z",
    transform: "translate(-133.535 -98.034)",
    fill: "#bcbec0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2452",
    "data-name": "Group 2452",
    transform: "translate(238.478 172.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2447",
    "data-name": "Group 2447",
    transform: "translate(52.839 74.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M221.44,254.946l-4.222-2.438V198.049l4.222,2.434Z",
    transform: "translate(-217.218 -196.156)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M220.077,254.77l3.278-1.895V198.419l-3.278,1.888Z",
    transform: "translate(-215.856 -195.98)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M221.44,201.094l3.278-1.888-4.222-2.439-3.278,1.893Z",
    transform: "translate(-217.218 -196.767)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2448",
    "data-name": "Group 2448",
    transform: "translate(51.276 57.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M222.145,206.561l-5.986-3.45V187.348l5.986,3.449Z",
    transform: "translate(-216.159 -184.664)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M220.213,206.312l4.637-2.68V187.87l-4.637,2.678Z",
    transform: "translate(-214.227 -184.415)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M222.145,191.663l4.637-2.678L220.8,185.53l-4.645,2.684Z",
    transform: "translate(-216.159 -185.53)",
    fill: "#2a4e68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2449",
    "data-name": "Group 2449",
    transform: "translate(45.947 65.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M221.7,192.424v6.907l-6,3.463v-6.9Z",
    transform: "translate(-211.05 -189.745)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M223.2,193.288l-4.638-2.679-6.01,3.465,4.648,2.686Z",
    transform: "translate(-212.549 -190.609)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M217.2,195.642l-4.648-2.686v6.911l4.648,2.674Z",
    transform: "translate(-212.549 -189.491)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450",
    transform: "translate(0 69.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M230.357,195.047v5.785l-46.295,26.727v-5.785Z",
    transform: "translate(-180.175 -192.804)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M231.612,195.771l-3.887-2.243L181.43,220.249l3.887,2.249Z",
    transform: "translate(-181.43 -193.528)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M185.317,213.875l-3.887-2.249v5.79l3.887,2.243Z",
    transform: "translate(-181.43 -184.905)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451",
    transform: "translate(52.839)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M221.44,208.835l-4.222-2.44V147.63l4.222,2.442Z",
    transform: "translate(-217.218 -145.738)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M220.077,208.658l3.278-1.895V148l-3.278,1.894Z",
    transform: "translate(-215.856 -145.561)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M221.44,150.682l3.278-1.894-4.222-2.44-3.278,1.892Z",
    transform: "translate(-217.218 -146.348)",
    fill: "#bcbec0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2473",
    "data-name": "Group 2473",
    transform: "translate(97.824 196.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2453",
    "data-name": "Group 2453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M106.143,164.405v7.855l-16.4,9.47v-7.854Z",
    transform: "translate(-84.46 -161.356)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M107.848,165.389l-5.282-3.049-16.4,9.47,5.282,3.049Z",
    transform: "translate(-86.165 -162.34)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M91.447,171.8l-5.282-3.049v7.857l5.282,3.047Z",
    transform: "translate(-86.165 -159.284)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2454",
    "data-name": "Group 2454",
    transform: "translate(14.934 6.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M96.279,169.214l4.5-2.6,35.56,20.526-4.5,2.6Z",
    transform: "translate(-96.279 -166.615)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M96.279,168.376V172.4l35.556,20.527V188.9Z",
    transform: "translate(-96.279 -165.777)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M120.362,183.116v4.031l4.5-2.6v-4.031Z",
    transform: "translate(-84.805 -159.992)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2455",
    "data-name": "Group 2455",
    transform: "translate(7.532 10.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M91.266,172.111l4.49-2.6,35.564,20.53-4.5,2.6Z",
    transform: "translate(-91.266 -169.515)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M91.266,171.274V175.3l35.552,20.531v-4.029Z",
    transform: "translate(-91.266 -168.677)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M115.345,186.019v4.029l4.5-2.6V183.42Z",
    transform: "translate(-79.793 -162.889)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2465",
    "data-name": "Group 2465",
    transform: "translate(53.212 34.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2457",
    "data-name": "Group 2457",
    transform: "translate(6.159 24.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2456",
    "data-name": "Group 2456",
    transform: "translate(0.537 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M126.955,206.4a1.091,1.091,0,0,0,1.019,0c.288-.164.288-.428,0-.589a1.117,1.117,0,0,0-1.019,0C126.669,205.973,126.669,206.237,126.955,206.4Z",
    transform: "translate(-126.741 -205.689)",
    fill: "#9c251f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M128.995,202.869v4.917h-.015a.681.681,0,0,1-.384.536,2.132,2.132,0,0,1-1.843,0,.685.685,0,0,1-.371-.536v-4.917Z",
    transform: "translate(-126.374 -202.12)",
    fill: "#121214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M126.757,203.646a2.073,2.073,0,0,0,1.843,0,.561.561,0,0,0,0-1.063,2.027,2.027,0,0,0-1.843,0A.562.562,0,0,0,126.757,203.646Z",
    transform: "translate(-126.377 -202.362)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2458",
    "data-name": "Group 2458",
    transform: "translate(3.641 21.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M132.313,202.013v1.1H132.3a1.9,1.9,0,0,1-1.115,1.558,5.952,5.952,0,0,1-5.388,0,1.9,1.9,0,0,1-1.122-1.558v-1.1Z",
    transform: "translate(-124.671 -199.813)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M125.792,204.279a5.989,5.989,0,0,0,5.388,0c1.488-.858,1.488-2.25,0-3.109a5.934,5.934,0,0,0-5.388,0C124.3,202.029,124.3,203.421,125.792,204.279Z",
    transform: "translate(-124.67 -200.523)",
    fill: "#ff9d26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2459",
    "data-name": "Group 2459",
    transform: "translate(4.695 16.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M130.931,197.74v6.074h-.018a1.374,1.374,0,0,1-.815,1.115,4.235,4.235,0,0,1-3.9,0,1.368,1.368,0,0,1-.815-1.115V197.74Z",
    transform: "translate(-125.385 -196.141)",
    fill: "#121214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M126.2,199.387a4.262,4.262,0,0,0,3.9,0,1.189,1.189,0,0,0,0-2.257,4.253,4.253,0,0,0-3.9,0A1.191,1.191,0,0,0,126.2,199.387Z",
    transform: "translate(-125.384 -196.657)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2460",
    "data-name": "Group 2460",
    transform: "translate(1.568 14.048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M135.067,197.481v1.692h-.033a2.947,2.947,0,0,1-1.722,2.411,9.241,9.241,0,0,1-8.314,0,2.952,2.952,0,0,1-1.732-2.411v-1.692Z",
    transform: "translate(-123.267 -194.081)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M124.991,200.98a9.21,9.21,0,0,0,8.317,0c2.293-1.327,2.293-3.474,0-4.8a9.129,9.129,0,0,0-8.317,0C122.692,197.506,122.7,199.653,124.991,200.98Z",
    transform: "translate(-123.267 -195.178)",
    fill: "#ff9d26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2461",
    "data-name": "Group 2461",
    transform: "translate(3.034 9.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M133.123,193.885v4.893h-.032a2.2,2.2,0,0,1-1.292,1.8,6.912,6.912,0,0,1-6.244,0,2.2,2.2,0,0,1-1.295-1.8v-4.893Z",
    transform: "translate(-124.26 -191.328)",
    fill: "#121214"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M125.554,196.517a6.939,6.939,0,0,0,6.244,0c1.733-1.005,1.733-2.618,0-3.619a6.912,6.912,0,0,0-6.244,0C123.832,193.9,123.832,195.512,125.554,196.517Z",
    transform: "translate(-124.259 -192.153)",
    fill: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2462",
    "data-name": "Group 2462",
    transform: "translate(0 4.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M137.126,191.836V194h-.037a3.717,3.717,0,0,1-2.176,3.03,11.644,11.644,0,0,1-10.52,0,3.719,3.719,0,0,1-2.188-3.03v-2.16Z",
    transform: "translate(-122.205 -187.548)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M124.391,196.257a11.58,11.58,0,0,0,10.52,0c2.9-1.68,2.9-4.388,0-6.071a11.662,11.662,0,0,0-10.52,0C121.475,191.869,121.486,194.576,124.391,196.257Z",
    transform: "translate(-122.203 -188.932)",
    fill: "#ff9d26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2463",
    "data-name": "Group 2463",
    transform: "translate(1.678 1.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M134.918,188.717v4.054h-.04a2.85,2.85,0,0,1-1.68,2.349,9.051,9.051,0,0,1-8.171,0,2.854,2.854,0,0,1-1.683-2.349v-4.054Z",
    transform: "translate(-123.341 -185.381)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M125.028,192.148a9.06,9.06,0,0,0,8.171,0c2.252-1.307,2.252-3.417,0-4.713a9.023,9.023,0,0,0-8.171,0C122.78,188.732,122.78,190.842,125.028,192.148Z",
    transform: "translate(-123.342 -186.458)",
    fill: "#ff9d26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2464",
    "data-name": "Group 2464",
    transform: "translate(2.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M133.721,187.569v1.407h-.027a2.4,2.4,0,0,1-1.426,1.984,7.579,7.579,0,0,1-6.886,0,2.383,2.383,0,0,1-1.428-1.984v-1.407Z",
    transform: "translate(-123.953 -184.756)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M125.382,190.458a7.579,7.579,0,0,0,6.886,0c1.9-1.087,1.9-2.872,0-3.972a7.616,7.616,0,0,0-6.886,0C123.477,187.586,123.477,189.372,125.382,190.458Z",
    transform: "translate(-123.953 -185.664)",
    fill: "#ff9d26"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2466",
    "data-name": "Group 2466",
    transform: "translate(40.509 23.388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M146.156,187.507v7.854l-16.4,9.47v-7.854Z",
    transform: "translate(-105.905 -173.737)",
    fill: "#ba6000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M153.852,191.95,130,178.181l-16.4,9.47,23.85,13.77Z",
    transform: "translate(-113.601 -178.181)",
    fill: "#ff9d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M137.451,198.364l-23.85-13.77v7.856l23.85,13.768Z",
    transform: "translate(-113.601 -175.125)",
    fill: "#ff8400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2467",
    "data-name": "Group 2467",
    transform: "translate(74.011 40.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M136.292,192.314l4.5-2.6,62.591,36.133-4.5,2.593Z",
    transform: "translate(-136.292 -189.718)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M136.292,191.476v4.03l62.588,36.132v-4.031Z",
    transform: "translate(-136.292 -188.88)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M178.683,216.784v4.031l4.5-2.595v-4.03Z",
    transform: "translate(-116.095 -178.058)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2468",
    "data-name": "Group 2468",
    transform: "translate(66.608 44.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M131.279,195.212l4.5-2.6L198.36,228.75l-4.5,2.6Z",
    transform: "translate(-131.279 -192.615)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M131.279,194.374v4.031l62.583,36.135v-4.029Z",
    transform: "translate(-131.279 -191.777)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M173.666,219.689v4.029l4.5-2.6,0-4.031Z",
    transform: "translate(-111.083 -180.954)",
    fill: "#939598"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2469",
    "data-name": "Group 2469",
    transform: "translate(123.557 71.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M189.828,212.72v7.854l-16.405,9.47V222.19Z",
    transform: "translate(-168.147 -209.673)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M191.531,213.7l-5.28-3.047-16.4,9.471,5.276,3.046Z",
    transform: "translate(-169.85 -210.656)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M175.125,220.119l-5.276-3.052v7.86l5.276,3.047Z",
    transform: "translate(-169.85 -207.602)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472",
    transform: "translate(53.157 19.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2470",
    "data-name": "Group 2470",
    transform: "translate(0 6.737)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M137.2,183.089v4.4a3.747,3.747,0,0,1-2.2,3.068,11.76,11.76,0,0,1-10.641,0,3.738,3.738,0,0,1-2.2-3.068v-4.4Z",
    transform: "translate(-122.166 -178.745)",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M124.368,187.559a11.769,11.769,0,0,0,10.641,0c2.934-1.692,2.934-4.454,0-6.141a11.769,11.769,0,0,0-10.641,0C121.434,183.1,121.434,185.867,124.368,187.559Z",
    transform: "translate(-122.168 -180.147)",
    fill: "#535359"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471",
    transform: "translate(0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M136.113,178.2v6.826a3.314,3.314,0,0,1-1.965,2.737,10.416,10.416,0,0,1-9.461,0,3.309,3.309,0,0,1-1.955-2.737V178.2Z",
    transform: "translate(-122.732 -174.339)",
    fill: "#303033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M124.686,182.171a10.4,10.4,0,0,0,9.461,0c2.618-1.507,2.618-3.955,0-5.458a10.48,10.48,0,0,0-9.461,0C122.083,178.215,122.083,180.663,124.686,182.171Z",
    transform: "translate(-122.731 -175.584)",
    fill: "#535359"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2479",
    "data-name": "Group 2479",
    transform: "translate(68.723 157.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2474",
    "data-name": "Group 2474",
    transform: "translate(1.564 74.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M71.735,244.746l-4.222-2.441V187.851l4.222,2.433Z",
    transform: "translate(-67.513 -185.957)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M70.373,244.572l3.285-1.893V188.218l-3.285,1.892Z",
    transform: "translate(-66.151 -185.782)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M71.735,190.9,75.02,189l-4.229-2.436-3.278,1.895Z",
    transform: "translate(-67.513 -186.568)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2475",
    "data-name": "Group 2475",
    transform: "translate(11.696 49.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M95.106,171.248v5.785l-18.1,10.451V181.7Z",
    transform: "translate(-73.122 -169)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M96.361,171.974l-3.884-2.248-18.1,10.448,3.887,2.248Z",
    transform: "translate(-74.376 -169.725)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M78.263,179.05,74.376,176.8v5.789l3.887,2.247Z",
    transform: "translate(-74.376 -166.354)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476",
    transform: "translate(5.315 59.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M79.206,178.065v6.9L73.2,188.435v-6.908Z",
    transform: "translate(-68.558 -175.385)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M80.7,178.93l-4.641-2.68-6.008,3.466,4.638,2.677Z",
    transform: "translate(-70.054 -176.25)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M74.692,181.274,70.054,178.6v6.9l4.638,2.681Z",
    transform: "translate(-70.054 -175.131)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    transform: "translate(0 57.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M72.44,196.363l-5.986-3.451V177.15L72.44,180.6Z",
    transform: "translate(-66.454 -174.47)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M70.508,196.114l4.641-2.68V177.672l-4.641,2.677Z",
    transform: "translate(-64.523 -174.221)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M72.44,181.462l4.641-2.677L71.1,175.334l-4.645,2.68Z",
    transform: "translate(-66.454 -175.334)",
    fill: "#2a4e68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478",
    transform: "translate(1.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M71.735,198.635,67.513,196.2V137.431l4.222,2.442Z",
    transform: "translate(-67.513 -135.539)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M70.373,198.458l3.285-1.893V137.8L70.373,139.7Z",
    transform: "translate(-66.151 -135.362)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M71.735,140.484l3.285-1.893-4.229-2.441-3.278,1.892Z",
    transform: "translate(-67.513 -136.149)",
    fill: "#bcbec0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2485",
    "data-name": "Group 2485",
    transform: "translate(192.281 228.804)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2480",
    "data-name": "Group 2480",
    transform: "translate(1.564 74.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M155.421,293.059l-4.222-2.434V236.167l4.222,2.438Z",
    transform: "translate(-151.199 -234.272)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M154.059,292.883l3.278-1.892V236.536l-3.278,1.893Z",
    transform: "translate(-149.837 -234.096)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M155.421,239.216l3.278-1.893-4.229-2.44-3.271,1.895Z",
    transform: "translate(-151.199 -234.883)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2481",
    "data-name": "Group 2481",
    transform: "translate(11.692 49.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M178.791,219.563v5.791L160.7,235.8v-5.785Z",
    transform: "translate(-156.802 -217.314)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M180.048,220.289l-3.888-2.249-18.1,10.454,3.9,2.245Z",
    transform: "translate(-158.059 -218.04)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M161.954,227.366l-3.9-2.245v5.786l3.9,2.243Z",
    transform: "translate(-158.059 -214.667)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2482",
    "data-name": "Group 2482",
    transform: "translate(5.312 59.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M162.887,226.38v6.905l-6,3.466v-6.907Z",
    transform: "translate(-152.239 -223.694)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M164.386,227.247l-4.638-2.686-6.01,3.472,4.644,2.679Z",
    transform: "translate(-153.738 -224.561)",
    fill: "#2a4e68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M158.382,229.592l-4.644-2.679v6.9l4.644,2.682Z",
    transform: "translate(-153.738 -223.441)",
    fill: "#1d374e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2483",
    "data-name": "Group 2483",
    transform: "translate(0 57.856)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M156.122,244.677l-5.982-3.452V225.465l5.982,3.449Z",
    transform: "translate(-150.14 -222.785)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M154.192,244.428l4.637-2.679V225.987l-4.637,2.679Z",
    transform: "translate(-148.21 -222.537)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M156.122,229.779l4.637-2.679-5.971-3.45-4.648,2.68Z",
    transform: "translate(-150.14 -223.65)",
    fill: "#2a4e68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2484",
    "data-name": "Group 2484",
    transform: "translate(1.564 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M155.421,246.95l-4.222-2.438V185.748l4.222,2.44Z",
    transform: "translate(-151.199 -183.853)",
    fill: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M154.059,246.773l3.278-1.892V186.118l-3.278,1.894Z",
    transform: "translate(-149.837 -183.677)",
    fill: "#939598"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M155.421,188.8l3.278-1.894-4.229-2.441-3.271,1.895Z",
    transform: "translate(-151.199 -184.464)",
    fill: "#bcbec0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2486",
    "data-name": "Group 2486",
    transform: "translate(70.286 93.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M195.293,212.766,67.513,138.989v-4.827l127.78,73.77Z",
    transform: "translate(-67.513 -73.512)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M154.059,207.729V202.9L254.81,144.733v4.825Z",
    transform: "translate(-26.278 -68.476)",
    fill: "#0f2034"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M163.968,93.084l-6.975,6.507L77.119,145.885l-9.606,7.849L195.294,227.5,300.34,171.817,286.3,160.922,172.49,95.563Z",
    transform: "translate(-67.513 -93.084)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2487",
    "data-name": "Group 2487",
    transform: "translate(198.066 170.143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M158.351,337.834l-4.292-2.484V184.127l4.292,2.484Z",
    transform: "translate(-154.059 -125.964)",
    fill: "#1d374e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M158.351,205.38l-4.292-2.484L202.2,170.43l52.607-25.7,4.3,2.476Z",
    transform: "translate(-154.059 -144.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M159.011,201.944,160.4,322.161l90.415-50.967.883-114.319Zm85.044,63.489-62.184,35.9-20.092-9.781V205.034l65.813-38,16.462,8.013Z",
    transform: "translate(-151.699 -138.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M183,299.418l-.071-.031-20.182-9.827v-86.7l.072-.046,65.884-38.035,16.626,8.088v90.571l-.075.044Zm-19.947-10.049,19.934,9.7,62.034-35.82v-90.2l-16.3-7.937-65.664,37.914Z",
    transform: "translate(-149.917 -135.184)",
    fill: "#24d2c1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M245.136,263.291l-62.182,35.9-20.1-9.783V202.891l65.811-38,16.473,8.013Z",
    transform: "translate(-149.869 -135.128)",
    fill: "#24d2c1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M156.966,204.581V355.8L257.72,297.635l2.153-13.428V160.95l-2.153-14.54ZM247.94,272.1,185.758,308l-20.1-9.783V211.7l65.811-38,16.473,8.013Z",
    transform: "translate(-152.673 -143.934)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2504",
    "data-name": "Group 2504",
    transform: "translate(61.693 152.056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M154.059,339.517l4.292-2.484V185.809l-4.292,2.484Z",
    transform: "translate(-17.685 -107.076)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M198.066,213.7l4.292-2.484-68.186-42.5L65.987,132.483l-4.293,2.479Z",
    transform: "translate(-61.693 -132.483)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M65.118,144.625,66,271.359,192.034,342.89l1.388-132.632ZM72.751,162.8l16.462-8.013,101.435,58.563V318.685l-20.092,3.383L72.751,265.6Z",
    transform: "translate(-60.061 -126.698)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M165.164,266.308l-2.913,6.758L118.63,242.8l2.916-1.68Z",
    transform: "translate(-34.566 -80.723)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M61.693,134.162V285.384l136.374,78.74V212.9Zm9.789,35.3,16.461-8.017,101.437,58.569V318.95l-43.623-25.19L138.6,311.014,71.482,272.262Z",
    transform: "translate(-61.693 -131.683)",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    transform: "translate(84.72 172.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2488",
    "data-name": "Group 2488",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M164.487,291.892c0,3.328-2.356,4.689-5.23,3.027l-34.943-20.275a11.62,11.62,0,0,1-5.24-9.074V253.386c0-3.331,2.356-4.689,5.24-3.027l34.943,20.272a11.626,11.626,0,0,1,5.23,9.067Z",
    transform: "translate(-119.074 -249.649)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2489",
    "data-name": "Group 2489",
    transform: "translate(33.706 20.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M144.881,266.006c0,.893-.676,1.24-1.487.769a3.221,3.221,0,0,1-1.491-2.491c0-.889.672-1.24,1.491-.763A3.232,3.232,0,0,1,144.881,266.006Z",
    transform: "translate(-141.903 -263.307)",
    fill: "#e31b25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(37.545 22.373)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M147.488,267.5c0,.893-.673,1.237-1.491.763a3.225,3.225,0,0,1-1.494-2.488c0-.892.676-1.236,1.494-.759A3.223,3.223,0,0,1,147.488,267.5Z",
    transform: "translate(-144.503 -264.802)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493",
    transform: "translate(25.427 21.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M139.287,266.886c0,.9-.673,1.24-1.494.766a3.232,3.232,0,0,1-1.5-2.488c0-.895.678-1.237,1.5-.762A3.207,3.207,0,0,1,139.287,266.886Z",
    transform: "translate(-136.296 -264.188)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492",
    transform: "translate(4.19 2.41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M142.111,268.511c0,.893-.67,1.237-1.484.763a3.233,3.233,0,0,1-1.493-2.485c0-.887.673-1.228,1.493-.757A3.21,3.21,0,0,1,142.111,268.511Z",
    transform: "translate(-139.134 -265.82)",
    fill: "#a7a9ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496",
    transform: "translate(25.427 26.553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M139.287,270.332c0,.892-.673,1.237-1.494.768a3.212,3.212,0,0,1-1.5-2.485c0-.9.678-1.243,1.5-.766A3.219,3.219,0,0,1,139.287,270.332Z",
    transform: "translate(-136.296 -267.634)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495",
    transform: "translate(4.19 2.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M142.111,271.955c0,.9-.67,1.237-1.484.766a3.208,3.208,0,0,1-1.493-2.477c0-.893.673-1.237,1.493-.769A3.205,3.205,0,0,1,142.111,271.955Z",
    transform: "translate(-139.134 -269.265)",
    fill: "#a7a9ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(25.427 31.644)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M139.287,273.782c0,.889-.673,1.228-1.494.759a3.2,3.2,0,0,1-1.5-2.48c0-.9.678-1.237,1.5-.766A3.217,3.217,0,0,1,139.287,273.782Z",
    transform: "translate(-136.296 -271.082)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(4.19 2.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M142.111,275.413c0,.89-.67,1.23-1.484.76a3.219,3.219,0,0,1-1.493-2.486c0-.893.673-1.234,1.493-.76A3.232,3.232,0,0,1,142.111,275.413Z",
    transform: "translate(-139.134 -272.713)",
    fill: "#a7a9ac"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2500",
    "data-name": "Group 2500",
    transform: "translate(33.706 27.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M148.727,278.96c0,2.68-1.534,3.988-3.411,2.907s-3.414-4.164-3.414-6.845v-3.691c0-2.681,1.531-3.994,3.414-2.909s3.411,4.165,3.411,6.845Z",
    transform: "translate(-141.903 -268.042)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501",
    transform: "translate(25.427 15.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M143.488,265.035c0,.895-1.624.688-3.594-.447s-3.6-2.8-3.6-3.691,1.623-.688,3.6.447S143.488,264.143,143.488,265.035Z",
    transform: "translate(-136.296 -260.341)",
    fill: "#a7a9ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(2.547 3.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M141.949,276.993c0,2.68-1.9,3.777-4.223,2.435l-12.711-7.345a9.353,9.353,0,0,1-4.217-7.316v-9.823c0-2.684,1.893-3.774,4.217-2.435l12.711,7.336a9.373,9.373,0,0,1,4.223,7.314Z",
    transform: "translate(-120.799 -251.936)",
    fill: "#24d2c1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2431",
    "data-name": "Group 2431",
    transform: "translate(414 159.783)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -289, -119.69)",
    filter: "url(#Rectangle_1128)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1128-2",
    "data-name": "Rectangle 1128",
    width: 162,
    height: 125,
    rx: 36,
    transform: "translate(289 119.9)",
    fill: "#343434"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(23 22.217)",
    fill: "#24d2c1"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x2: 47.088,
    transform: "translate(58.95 36.36)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M0,0H32.414",
    transform: "translate(27.959 62.77)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 95.284,
    transform: "translate(27.959 78.18)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x2: 50.541,
    transform: "translate(27.959 93.18)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.5c9591264b6a77d21d41e13957a2d70f.svg";
export { ForwardRef as ReactComponent };